import { gql } from "../gql";
import "./fragments";

export const APPOINTMENTS_QUERY = gql(`
  query Appointments($salonId: ID!, $filters: AppointmentFilterInput) {
    appointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const APPOINTMENT_QUERY = gql(`
  query Appointment($salonId: ID!, $id: ID!) {
    appointment(salonId: $salonId, id: $id) {
      ...AppointmentDetail @unmask
    }
  }
`);

// My Appointments Queries - Worker-specific
export const MY_APPOINTMENTS_QUERY = gql(`
  query MyAppointments($salonId: ID!, $filters: MyAppointmentFilterInput) {
    myAppointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const MY_TODAYS_APPOINTMENTS_QUERY = gql(`
  query MyTodaysAppointments($salonId: ID!, $filters: MyTodayAppointmentFilterInput) {
    myTodaysAppointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const MY_UPCOMING_APPOINTMENTS_QUERY = gql(`
  query MyUpcomingAppointments($salonId: ID!, $filters: MyUpcomingAppointmentFilterInput) {
    myUpcomingAppointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const TODAYS_APPOINTMENTS_CURSOR_QUERY = gql(`
  query TodaysAppointments($salonId: ID!, $filters: TodayAppointmentFilterInput) {
    todaysAppointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const CREATE_APPOINTMENT_MUTATION = gql(`
  mutation CreateAppointment($salonId: ID!, $input: CreateAppointmentInput!) {
    createAppointment(salonId: $salonId, input: $input) {
      ...AppointmentList @unmask
    }
  }
`);

export const UPDATE_APPOINTMENT_MUTATION = gql(`
  mutation UpdateAppointment($salonId: ID!, $appointmentId: ID!, $input: UpdateAppointmentInput!) {
    updateAppointment(salonId: $salonId, appointmentId: $appointmentId, input: $input) {
      ...AppointmentDetail @unmask
    }
  }
`);

export const UPDATE_APPOINTMENT_SERVICE_WORKER_MUTATION = gql(`
  mutation UpdateAppointmentServiceWorker(
    $salonId: ID!
    $appointmentId: ID!
    $input: UpdateAppointmentServiceWorkerInput!
  ) {
    updateAppointmentServiceWorker(
      salonId: $salonId
      appointmentId: $appointmentId
      input: $input
    ) {
      id
      workerId
      worker {
        id
        color
        user {
          firstName
          lastName
        }
      }
    }
  }
`);

export const COMPLETE_APPOINTMENT_MUTATION = gql(`
  mutation CompleteAppointment($salonId: ID!, $appointmentId: ID!) {
    completeAppointment(salonId: $salonId, appointmentId: $appointmentId) {
      id
      bookingStatus
      outcome
      customer {
        id
        totalPoints
        totalVisits
        currentTier {
          name
          color
        }
      }
    }
  }
`);

export const OWNER_CANCEL_APPOINTMENT_MUTATION = gql(`
  mutation OwnerCancelAppointment($salonId: ID!, $appointmentId: ID!, $input: OwnerCancelAppointmentInput!) {
    ownerCancelAppointment(salonId: $salonId, appointmentId: $appointmentId, input: $input) {
      ...AppointmentDetail @unmask
    }
  }
`);

export const DELETE_APPOINTMENT_MUTATION = gql(`
  mutation DeleteAppointment($salonId: ID!, $appointmentId: ID!) {
    deleteAppointment(salonId: $salonId, appointmentId: $appointmentId)
  }
`);

export const INCOMING_APPOINTMENTS_CURSOR_QUERY = gql(`
  query IncomingAppointments($salonId: ID!, $filters: IncomingAppointmentFilterInput) {
    incomingAppointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const WAITING_TO_CONFIRM_APPOINTMENTS_QUERY = gql(`
  query WaitingToConfirmAppointments($salonId: ID!, $filters: WaitingToConfirmAppointmentFilterInput, $after: String) {
    waitingToConfirmAppointments(salonId: $salonId, filters: $filters, after: $after) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const DASHBOARD_METRICS_QUERY = gql(`
  query DashboardMetrics($salonId: ID!) {
    dashboardMetrics(salonId: $salonId) {
      appointments {
        total
        completed
        confirmed
        pending
        cancelled
      }
      revenue {
        today
        formatted
      }
      workers {
        available
        total
        utilization
      }
      upcoming {
        nextHour
        nextTwoHours
        today
      }
      alerts {
        overbooked
        unassigned
        conflicts
      }
      requests
      tabs {
        today
        incoming
        requests
      }
      lastUpdated
    }
  }
`);

export const VALIDATE_BOOKING_CONSTRAINTS_QUERY = gql(`
  query ValidateBookingConstraints($input: ValidateBookingConstraintsInput!) {
    validateBookingConstraints(input: $input) {
      isValid
      errors
      availability {
        isAvailable
        availableSlots
        totalSlots
        reason
      }
    }
  }
`);

export const UPDATE_APPOINTMENT_SERVICES_MUTATION = gql(`
  mutation UpdateAppointmentServices($salonId: ID!, $appointmentId: ID!, $input: UpdateAppointmentServicesInput!) {
    updateAppointmentServices(salonId: $salonId, appointmentId: $appointmentId, input: $input) {
      ...AppointmentDetail @unmask
    }
  }
`);
